import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AppelapiService } from './appelapi.service';

@Injectable()
export class MailService {

  constructor(private http: HttpClient, private api: AppelapiService) { }

  sendMail(sujet: string, message: string, nom: string, email: string): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'x-api-key': 'vo6U39MUy331hwaOPzzNw5MT6CUUuoowT7xMxEHa',
      })
    }

    const data = {
      'sujet': sujet,
      'message': message,
      'nom': nom,
      'email': email
    }

    return this.api.post<any>(`${environment.lien.api.mail}`, data, httpOptions);
  }
}